/* eslint-disable import/prefer-default-export */
import type { VariantDisplayType } from 'autogen/swagger/all';
import { css } from 'styled-components';
import { ColorBrandBlue1, ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import type { SwatchRendererType } from './types';

type SizeValue = {
    width: string | null;
    height: string;
};

type ColorImageSizeValue = {
    width: string;
    height: string;
};

// Attention! These values can only be used for lg-sizes
const DisplayTypeSize: { [key in VariantDisplayType]: key extends 'Text' ? SizeValue : ColorImageSizeValue } = {
    Color: {
        width: '48px',
        height: '48px'
    },
    Image: {
        width: '56px',
        height: '72px'
    },
    Text: {
        width: '60px',
        height: '40px'
    }
};

function selectedStyling({ $size }: { $size: SwatchRendererType['size'] }) {
    return css`
        border: 0;
        ${
            $size === 'lg'
                ? css`
                  outline: 2px solid ${ColorBrandBlue1};
                  outline-offset: -2px;
                  box-shadow: inset 0 0px 0 4px ${ColorNeutralWhite};
              `
                : css`
                  outline: 1px solid ${ColorBrandBlue1};
                  outline-offset: -1px;
                  box-shadow: inset 0 0px 0 2px ${ColorNeutralWhite};
              `
        }
    `;
}

function swatchStateStyling({ $size }: { $size: SwatchRendererType['size'] }) {
    return css`
        &:focus-visible,
        &:active {
            text-decoration: none;
            ${selectedStyling({ $size })}
        }

        ${breakpoint.up(sizes.xl)} {
            &:hover,
            &:focus {
                text-decoration: none;
                ${selectedStyling({ $size })}
            }
        }
    `;
}

export { DisplayTypeSize, swatchStateStyling, selectedStyling };
